// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* .tableBox >>> .el-table__expand-icon:after {\n  content: '';\n}\n.tableBox >>> .el-table__expand-icon > i {\n  display: none;\n} */\n/* .tableBox >>> .el-table__expand-column {\n  border-right: none;\n} */\n.tableBox[data-v-f39bbcae] .el-table__expanded-cell[class*=cell] {\n  padding: 5px 50px !important;\n}\n", ""]);
// Exports
module.exports = exports;
